<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center flex-fill gap-3">
        <div class="d-flex ali-items-center gap-2">
          <h6 class="modal-title mb-0" i18n>AI Settings</h6>
          <app-page-help articleId="iq9oar78ng" videoId="mt1mm-Y0hiA"></app-page-help>
        </div>
        <div class="flex-fill"></div>
        <button
          class="btn btn-outline-ai btn-sm btn-pill px-3"
          (click)="togglesForm.get('isEnabled').setValue(!aiSettings?.isEnabled)"
          [class.active]="aiSettings?.isEnabled"
          matTooltip="Switch the Advance Intelligence feature on or off here."
          i18n-matTooltip
        >
          <i class="cs-icon cs-icon-ai"></i> <ng-container i18n>Advance Intelligence</ng-container>
        </button>
        <button
          class="btn btn-secondary-primary"
          matTooltip="Try out the AI! Ask a question and see how it responds."
          i18n-matTooltip
          (click)="isTestPopoverOpen = !isTestPopoverOpen"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
        >
          <i class="cs-icon cs-icon-ai"></i>
          <ng-container i18n>Test AI</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="alert alert-secondary-warning" *ngIf="aiSettings?.contractId && !aiSettings?.isContractSigned">
        <ng-container i18n
          >Please sign the contract to use Advance Intelligence feature. If you have signed the contract, please click
          the Refresh button to refresh the AI settings.</ng-container
        >

        <button class="btn btn-secondary-info ml-3" (click)="onRefreshSettings()" i18n>Refresh</button>
        <button class="btn btn-warning ml-3" (click)="onSignAIContract()" i18n>Sign</button>
      </div>
      <div class="d-flex align-items-center">
        <h6 class="text-uppercase mb-0" i18n>Train Your AI</h6>
        <div class="flex-fill"></div>
        <app-form-switch
          label="Automatically send AI replies"
          i18n-label
          [inline]="true"
          [formControl]="togglesForm.get('isAutomateSendReplies')"
          labelPosition="before"
          matTooltip="Enable this toggle for automatically sending AI based messages to guests"
          i18n-matTooltip
          matTooltipPosition="below"
        ></app-form-switch>
      </div>
      <div class="mt-3 container-box">
        <div class="d-flex align-items-center border-bottom pr-3 pt-2">
          <ul class="nav top-navbar">
            <li [class.active]="activeTab === tabs.General" (click)="activeTab = tabs.General">
              <a class="text-link">
                <span matTooltip="Upload Docs & add FAQs to train Advance Intelligence." i18n-matTooltip i18n
                  >Knowledge Base</span
                >
                <a
                  class="text-dark"
                  openArticleId="w7n415de3j"
                  matTooltip="Click here to see the associated help article."
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-question-circle"></i>
                </a>
              </a>
            </li>
            <li [class.active]="activeTab === tabs.Settings" (click)="activeTab = tabs.Settings">
              <a class="text-link">
                <span matTooltip="Edit settings of Advance Intelligence related features." i18n-matTooltip i18n
                  >Settings</span
                >
                <a
                  class="text-dark"
                  openArticleId="i1fj8vsy22"
                  matTooltip="Click here to see the associated help article."
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-question-circle"></i>
                </a>
              </a>
            </li>
            <li [class.active]="activeTab === tabs.RentalDetails" (click)="activeTab = tabs.RentalDetails">
              <a class="text-link">
                <span
                  matTooltip="Control permissions for Advance Intelligence on all rental related fields."
                  i18n-matTooltip
                  i18n
                  >Rental Details</span
                >
                <a
                  class="text-dark"
                  openArticleId="8ptpayt8ks"
                  matTooltip="Click here to see the associated help article."
                >
                  <i class="cs-icon cs-icon-question-circle"></i>
                </a>
              </a>
            </li>
            <li [class.active]="activeTab === tabs.IgnoreList" (click)="activeTab = tabs.IgnoreList">
              <a class="text-link">
                <span
                  matTooltip="Block specific Booking conversation, Email address, Rental or Regex Pattern from Advance Intelligence auto reponses"
                  i18n-matTooltip
                  i18n
                >
                  Ignore List
                </span>

                <a
                  class="text-dark"
                  openArticleId="fv6x6tt69i"
                  matTooltip="Click here to see the associated help article."
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-question-circle"></i>
                </a>
              </a>
            </li>
            <li [class.active]="activeTab === tabs.IncidentTask" (click)="activeTab = tabs.IncidentTask">
              <a class="text-link">
                <span> Incident </span>

                <a
                  class="text-dark"
                  openArticleId="hhQT8ZvJyJoUpna2ASN5nT"
                  matTooltip="Click here to see the associated help article."
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-question-circle"></i>
                </a>
              </a>
            </li>
            <li [class.active]="activeTab === tabs.CreditRecharge" (click)="activeTab = tabs.CreditRecharge">
              <a class="text-link">
                <span matTooltip="Control AI subscription, recharge & balance options" i18n-matTooltip i18n
                  >Credit Recharge</span
                >
                <a
                  class="text-dark"
                  openArticleId="9tvfav7kag"
                  matTooltip="Click here to see the associated help article."
                  i18n-matTooltip
                  ><i class="cs-icon cs-icon-question-circle"></i>
                </a>
              </a>
            </li>
            <li [class.active]="activeTab === tabs.OffCalendar" (click)="activeTab = tabs.OffCalendar">
              <a class="text-link">
                <span matTooltip="Control AI's availability on the calendar" i18n>Schedule AI</span>
                <a
                  class="text-dark"
                  openArticleId="6Z8yrJckvGN1AQGrZyBUMQ"
                  matTooltip="Click here to see the associated help article."
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-question-circle"></i>
                </a>
              </a>
            </li>
          </ul>
          <div class="flex-fill"></div>
        </div>
        <ng-template [ngTemplateOutlet]="base" *ngIf="activeTab === tabs.General"></ng-template>
        <ng-template [ngTemplateOutlet]="settings" *ngIf="activeTab === tabs.Settings"></ng-template>
        <ng-container *ngIf="activeTab === tabs.RentalDetails">
          <app-ai-responder-rental-details [settings]="aiSettings"></app-ai-responder-rental-details>
        </ng-container>
        <ng-container *ngIf="activeTab === tabs.IgnoreList">
          <app-ai-responder-ignore-list [settings]="aiSettings"></app-ai-responder-ignore-list>
        </ng-container>
        <ng-container *ngIf="activeTab === tabs.IncidentTask">
          <app-ai-responder-incident-task [settings]="aiSettings"></app-ai-responder-incident-task>
        </ng-container>
        <ng-container *ngIf="activeTab === tabs.CreditRecharge">
          <app-ai-auto-credit-recharge></app-ai-auto-credit-recharge>
        </ng-container>
        <ng-container *ngIf="activeTab === tabs.OffCalendar">
          <app-ai-off-calendar [settings]="aiSettings"></app-ai-off-calendar>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<ng-template #base>
  <mat-accordion [hideToggle]="true" class="p-3 d-flex flex-column gap-3">
    <mat-expansion-panel
      class="shadow-none border rounded m-0"
      [expanded]="true"
      [class.bg-active2]="!panel2.expanded"
      #panel2
    >
      <mat-expansion-panel-header [class.border-bottom]="panel2.expanded" class="rounded-0">
        <mat-panel-title
          class="d-flex align-items-center"
          matTooltip="AI takes help of added Documents while responding to guests"
          i18n-matTooltip
        >
          <i class="fas mr-1" [ngClass]="'fa-arrow-' + (panel2.expanded ? 'down' : 'right')"></i>
          <ng-container i18n>Documents</ng-container>
        </mat-panel-title>
        <mat-panel-description class="d-flex" (click)="$event.stopPropagation()">
          <div class="flex-fill"></div>
          <app-form-switch
            matTooltip="Include or exclude uploaded documents from Advance Intelligence generated responses."
            i18n-matTooltip
            i18n-label
            label="Active"
            [inline]="true"
            labelPosition="before"
            [formControl]="togglesForm.get('isDocumentsEnabled')"
          ></app-form-switch>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ai-responder-documents></ai-responder-documents>
    </mat-expansion-panel>
    <mat-expansion-panel class="shadow-none border rounded m-0" [class.bg-active2]="!panel3.expanded" #panel3>
      <mat-expansion-panel-header [class.border-bottom]="panel3.expanded" class="rounded-0">
        <mat-panel-title
          class="d-flex align-items-center"
          matTooltip="AI takes help of added FAQs while responding to guests"
        >
          <i class="fas mr-1" [ngClass]="'fa-arrow-' + (panel3.expanded ? 'down' : 'right')"></i>
          <ng-container i18n>FAQ</ng-container>
        </mat-panel-title>
        <mat-panel-description class="d-flex" (click)="$event.stopPropagation()">
          <div class="flex-fill"></div>
          <app-form-switch
            matTooltip="Include or exclude added FAQs from Advance Intelligence generated responses."
            i18n-matTooltip
            i18n-label
            label="Active"
            [inline]="true"
            labelPosition="before"
            [formControl]="togglesForm.get('isFaqEnabled')"
          ></app-form-switch>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ai-responder-faq *ngIf="panel3.expanded" [faqs]="aiSettings?.faqs"></ai-responder-faq>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
<ng-template #settings>
  <form [formGroup]="settingsForm" novalidate class="p-3">
    <div class="row mb-3">
      <div class="col-lg-6">
        <div class="bg-default2 p-3 rounded">
          <mat-form-field2
            matTooltip="This name will appear in AI based message signature which is sent to guests."
            i18n-matTooltip
            matTooltipPosition="above"
          >
            <mat-label i18n>AI Name</mat-label>
            <input type="text" matInput formControlName="name" />
            <mat-error *ngIf="settingsForm.get('name').hasError('required') && settingsForm.get('name').touched">
              <ng-container i18n>AI Name is required</ng-container>
            </mat-error>
          </mat-form-field2>
          <div>
            <mat-form-field2
              matTooltip="It determines which channels the AI responds to. Applied to All if no channel is selected."
              i18n-matTooltip
              matTooltipPosition="above"
            >
              <app-select
                [items]="channels$ | async"
                [formControl]="settingsForm.get('channels')"
                [multiple]="true"
                bindValue="id"
                bindLabel="name"
                [searchable]="true"
                placeholder="Select Channels"
                i18n-placeholder
              >
                <ng-template selectLabel let-items="items" let-removeItem="removeItem">
                  <ng-container *ngFor="let item of items">
                    <div
                      class="d-inline-flex align-items-center gap-1 bg-default3 btn-pill p-1"
                      (click)="$event.stopPropagation()"
                    >
                      <ng-template [ngTemplateOutlet]="image" [ngTemplateOutletContext]="{ item: item }"></ng-template>
                      <a href="javascript:;" (click)="removeItem(item)" class="text-light"
                        ><i class="far fa-times-circle"></i
                      ></a>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template selectItem let-item="item">
                  <div class="d-flex align-items-center gap-1">
                    <ng-template [ngTemplateOutlet]="image" [ngTemplateOutletContext]="{ item: item }"></ng-template>
                  </div>
                </ng-template>
                <ng-template #image let-item="item">
                  <ng-container *ngIf="item">
                    <img [src]="item.id | inquirySourceIcon" class="w-100" style="max-width: 16px; max-height: 16px" />
                    {{ item.name | titleCase }}
                  </ng-container>
                </ng-template>
              </app-select>
            </mat-form-field2>
          </div>
          <div></div>
          <div class="d-flex flex-column" style="gap: 1rem; font-size: 15px">
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('isAutoRespondToNewBookings').value"
              [class.text-bold]="settingsForm.get('isAutoRespondToNewBookings').value"
            >
              <ng-container i18n>Automatically respond to new bookings</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Automatically send Advance Intelligence's generated replies to new booking inquiries"
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('isAutoRespondToNewBookings')"
              ></app-form-switch>
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('isDelayResponse').value"
              [class.text-bold]="settingsForm.get('isDelayResponse').value"
            >
              <ng-container i18n>Delay response by</ng-container>
              <input
                formControlName="delayResponse"
                class="form-control mx-1 px-2"
                matTooltip="Set how many minutes Advance Intelligence holds off before replying"
                i18n-matTooltip
                type="number"
                step="1"
                style="width: 80px"
                [class.text-danger]="settingsForm.get('delayResponse').invalid"
              />
              <ng-container i18n>minutes</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Set a time delay for Advance Intelligence's automated responses to guests."
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('isDelayResponse')"
              ></app-form-switch>
            </div>
            <div *ngIf="settingsForm.get('delayResponse').invalid">
              <mat-error *ngIf="settingsForm.get('delayResponse').errors?.min" i18n
                >Delay response must be greater than 1</mat-error
              >
              <mat-error *ngIf="settingsForm.get('delayResponse').errors?.integer" i18n
                >Delay response must be integer</mat-error
              >
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('isRespondEvenIfResponded').value"
              [class.text-bold]="settingsForm.get('isRespondEvenIfResponded').value"
            >
              <ng-container i18n>Respond even if human response is already sent</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Allow AI to reply even after a manual response has been sent."
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('isRespondEvenIfResponded')"
              ></app-form-switch>
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('ignoreCancellations').value"
              [class.text-bold]="settingsForm.get('ignoreCancellations').value"
            >
              <ng-container i18n>Ignore cancellation messages</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Prevent AI from auto-replying to cancellation messages from guests."
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('ignoreCancellations')"
              ></app-form-switch>
            </div>
            <div class="row">
              <div
                class="col-sm-6"
                matTooltip="Limit the number of automatic replies sent to guests in a single conversation"
                i18n-matTooltip
                matTooltipPosition="right"
              >
                <div class="d-flex align-items-center">
                  <div class="text-nowrap" i18n>Maximum Replies</div>
                  <input
                    type="number"
                    class="form-control mx-1 px-2"
                    formControlName="maxReplies"
                    style="width: 80px"
                  />
                </div>
                <div *ngIf="settingsForm.get('maxReplies').invalid">
                  <mat-error *ngIf="settingsForm.get('maxReplies').errors?.required" i18n
                    >Maximum Replies is required</mat-error
                  >
                  <mat-error *ngIf="settingsForm.get('maxReplies').errors?.min" i18n
                    >Maximum Replies must be greater than 1</mat-error
                  >
                  <mat-error *ngIf="settingsForm.get('maxReplies').errors?.integer" i18n
                    >Maximum Replies must be integer</mat-error
                  >
                </div>
              </div>
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('isCreateDrafts').value"
              [class.text-bold]="settingsForm.get('isCreateDrafts').value"
            >
              <ng-container i18n>Create draft replies</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Allow AI to create draft message when guest messages are received."
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('isCreateDrafts')"
              ></app-form-switch>
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('notifyMeEnabled').value"
              [class.text-bold]="settingsForm.get('notifyMeEnabled').value"
            >
              <ng-container i18n>Notify Me by AI</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Enable AI notifications when a guest places an order or reports a complaint."
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('notifyMeEnabled')"
              ></app-form-switch>
            </div>
            <div class="pl-3">
              <div class="d-flex"
                   style="gap: 0.5rem">
                <mat-checkbox *ngFor="let option of notifyMeOptions"
                              [checked]="isNotifyMeOptionSelected(option.value)"
                              [disabled]="!settingsForm.get('notifyMeEnabled').value"
                              (change)="onToggleNotifyMeOption(option.value, $event.checked)">
                  {{ option.label }}
                </mat-checkbox>
              </div>
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('ignoreCourtesies').value"
              [class.text-bold]="settingsForm.get('ignoreCourtesies').value"
            >
              <ng-container i18n>Ignore Courtesies</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Ignore OK, Thank you, and similar messages"
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('ignoreCourtesies')"
              ></app-form-switch>
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('isTranslateEnabled').value"
              [class.text-bold]="settingsForm.get('isTranslateEnabled').value"
            >
              <ng-container i18n>Enable multilingual guest message translation</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Messages from guests in other languages will be auto-translated to English, with AI-generated reply suggestions"
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('isTranslateEnabled')"
              ></app-form-switch>
            </div>
            <div
              class="d-flex align-items-center"
              [class.text-black]="settingsForm.get('isGenerateGuestSummary').value"
              [class.text-bold]="settingsForm.get('isGenerateGuestSummary').value"
            >
              <ng-container i18n>Generate guest summaries</ng-container>
              <app-form-switch
                class="ml-auto"
                matTooltip="Generate AI summaries for guest history in the inquiries inbox."
                i18n-matTooltip
                matTooltipPosition="right"
                [inline]="true"
                [formControl]="settingsForm.get('isGenerateGuestSummary')"
              ></app-form-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="bg-default2 p-3 rounded">
          <label class="d-block mb-3 text-black">
            <ng-container i18n>Tone of Voice</ng-container>
            <i
              class="fal fa-info-circle ml-1"
              matTooltip="Set the tone for how the AI will chat with guests."
              i18n-matTooltip
              matTooltipPosition="above"
            ></i>
          </label>
          <mat-radio-group formControlName="tone" class="d-flex flex-column" style="gap: 1rem">
            <ng-container *ngFor="let item of toneOptions">
              <mat-radio-button [value]="item.id">
                <div>
                  <div class="text-black text-bold">{{ item.label }}</div>
                  <div class="text-muted" style="font-size: 12px">{{ item.example }}</div>
                </div>
              </mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="d-flex px-4 pb-4">
      <button
        class="btn btn-secondary-info ml-auto"
        matTooltip="Save your changes every time you make any change in AI Settings"
        i18n-matTooltip
        [disabled]="isSaving$ | async"
        (click)="onSaveSettings(settingsForm)"
      >
        <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </form>
</ng-template>

<ng-template
  #test
  cdkConnectedOverlay
  [cdkConnectedOverlayWidth]="500"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayDisableClose]="true"
  [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' }]"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isTestPopoverOpen"
  cdkConnectedOverlayPanelClass="tokeet-ai-chat-panel"
>
  <form [formGroup]="testForm" class="bg-white dropdown-shadow overflow-auto rounded">
    <div>
      <div class="text-primary p-4 d-flex align-items-center tokeet-ai-chat-header gap-3">
        <div class="rounded-circle bg-white d-flex align-items-center justify-content-center tokeet-ai-chat-icon">
          <i class="cs-icon cs-icon-ai"></i>
        </div>
        <div>
          <h6 class="text-xxl mb-1" i18n>I'm Advance Intelligence</h6>
          <div i18n>Chat with me now that your bot has been trained and I'll do my best to answer.</div>
        </div>
      </div>
      <div class="px-4 pt-4 pb-2">
        <app-rental-select
          [multiple]="false"
          [ctrl]="testForm.get('rentalId')"
          label="Rental"
          i18n-label
          (selectedValuesChange)="testForm.get('inquiryId').reset()"
        >
        </app-rental-select>
        <app-booking-select
          [multiple]="false"
          [required]="true"
          [ctrl]="testForm.get('inquiryId')"
          label="Inquiry"
          i18n-label
          [rentalId]="testForm.get('rentalId').value"
        >
        </app-booking-select>
        <mat-form-field2>
          <mat-label i18n>Tone of Voice</mat-label>
          <app-select
            bindValue="id"
            bindLabel="label"
            [searchable]="false"
            [multiple]="false"
            [required]="true"
            [items]="toneOptions"
            [formControl]="testForm.get('tone')"
          >
          </app-select>
        </mat-form-field2>
        <mat-form-field2>
          <mat-label i18n>Question</mat-label>
          <textarea
            matInput
            rows="5"
            formControlName="message"
            cdkTextareaAutosize
            placeholder="Ask questions based on the documents/FAQs you added in Knowledge base"
            i18n-placeholder
            required
          ></textarea>
          <mat-error *ngIf="testForm.get('message').touched && testForm.get('message').errors?.required" i18n>
            Question is required
          </mat-error>
        </mat-form-field2>
        <div
          class="border2 rounded p-3 mt-3 w-100 bg-light"
          *ngIf="!!testForm.get('answer').value"
          style="height: 200px; overflow: auto"
        >
          <div [innerHtml]="testForm.get('answer').value"></div>
        </div>
      </div>
      <div class="d-flex justify-content-end px-4 pt-0 pb-4 gap-3">
        <button class="btn btn-outline-light" (click)="isTestPopoverOpen = false">
          <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
        </button>
        <button
          class="btn btn-secondary-info"
          [disabled]="!isTestFormChanged || !testForm.valid || isGeneratingResponse"
          (click)="onTest(testForm)"
        >
          <i class="fa fa-spin fa-spinner" *ngIf="isGeneratingResponse"></i>
          <i *ngIf="!isGeneratingResponse" class="cs-icon cs-icon-send"></i>
          <ng-container i18n>Send</ng-container>
        </button>
      </div>
    </div>
  </form>
</ng-template>
